module.exports = __webpack_public_path__ + "static/media/1.49baf7df.jpg";